import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EditKnowledgeForCandidateResponse extends BackendResponse {}
export interface EditKnowledgeForCandidateParameters extends NextApiParams {
  knowledgeId: number;
  comment: string;
  knowledgeType: number;
  expirationDate: string | null;
  level: number;
}

export const editKnowledgeForCandidate = withNextApi<
  EditKnowledgeForCandidateResponse,
  EditKnowledgeForCandidateParameters
>("/cvp/CvpEditKnowledgeForCandidate");
